// Redux/Reducers/MessageReducers.js
import {
  MESSAGE_CREATE_REQUEST,
  MESSAGE_CREATE_SUCCESS,
  MESSAGE_CREATE_FAIL,
  MESSAGE_CREATE_RESET,
  MESSAGE_MY_LIST_REQUEST,
  MESSAGE_MY_LIST_SUCCESS,
  MESSAGE_MY_LIST_FAIL,
  MESSAGE_MY_LIST_RESET,
  MESSAGE_DELETE_REQUEST,
  MESSAGE_DELETE_SUCCESS,
  MESSAGE_DELETE_FAIL,
  MESSAGE_DELETE_RESET,
  MESSAGE_REPLY_REQUEST,
  MESSAGE_REPLY_SUCCESS,
  MESSAGE_REPLY_FAIL,
  MESSAGE_REPLY_RESET,
} from "../Constants/MessageConstants";

// Create message reducer
export const messageCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case MESSAGE_CREATE_REQUEST:
      return { loading: true };
    case MESSAGE_CREATE_SUCCESS:
      return { loading: false, success: true, message: action.payload };
    case MESSAGE_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case MESSAGE_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

// Get user messages reducer
export const messageMyListReducer = (state = { messages: [] }, action) => {
  switch (action.type) {
    case MESSAGE_MY_LIST_REQUEST:
      return { loading: true, messages: [] };
    case MESSAGE_MY_LIST_SUCCESS:
      return { loading: false, messages: action.payload };
    case MESSAGE_MY_LIST_FAIL:
      return { loading: false, error: action.payload };
    case MESSAGE_MY_LIST_RESET:
      return { messages: [] };
    default:
      return state;
  }
};

// Delete message reducer
export const messageDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case MESSAGE_DELETE_REQUEST:
      return { loading: true };
    case MESSAGE_DELETE_SUCCESS:
      return { loading: false, success: true };
    case MESSAGE_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case MESSAGE_DELETE_RESET:
      return {};
    default:
      return state;
  }
};

// User reply to message reducer
export const messageReplyReducer = (state = {}, action) => {
  switch (action.type) {
    case MESSAGE_REPLY_REQUEST:
      return { loading: true };
    case MESSAGE_REPLY_SUCCESS:
      return { loading: false, success: true, message: action.payload };
    case MESSAGE_REPLY_FAIL:
      return { loading: false, error: action.payload };
    case MESSAGE_REPLY_RESET:
      return {};
    default:
      return state;
  }
};